import { CompetitionsPageContent } from '@/components/Competition'
import { useLanguage } from '@/hooks/Contexts'
import { API_URL, SOCIAL_MEDIA_FACEBOOK } from '@/utils/Consts'
import * as Sentry from '@sentry/nextjs'
import axios from 'lib/axios'
import { GetServerSideProps, InferGetServerSidePropsType } from 'next'
import Head from 'next/head'
import { Fragment } from 'react'

export default function CompetitionsPage({ data }: InferGetServerSidePropsType<typeof getServerSideProps>) {
  const { navigation: navStr } = useLanguage()
  return (
    <Fragment>
      <Head>
        <title>{navStr.app_name}</title>
        <meta name='title' content={navStr.app_name} key='title' />
        <meta property='og:title' content={navStr.app_name} key='og:title' />
        <meta name='twitter:title' content={navStr.app_name} key='twitter:title' />
        <meta name='description' content={navStr.meta.description2} key='description' />
        <meta name='twitter:description' content={navStr.meta.description2} key='twitter:description' />
        <meta name='og:description' content={navStr.meta.description2} key='og:description' />
        <meta property='og:type' content='article' key='og:type' />
        <meta property='article:publisher' content={SOCIAL_MEDIA_FACEBOOK} />
      </Head>
      <CompetitionsPageContent dataFetched={data} />
    </Fragment>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  let data = []
  try {
    const res = await axios.get(API_URL.competitionList + '?store_id=1&source=c', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'accept': 'application/json',
        'Content-Type': 'application/json',
        'cookie': context.req.headers.cookie || [],
      },
      withCredentials: true,
    })
    data = res?.data?.data || []
  } catch (e) {
    Sentry.captureException(e)
    data = []
  }
  return { props: { data } }
}
